import { AUTH_ENDPOINTS } from "./http/config";
import api from '@/api/Api';
import { getAuthToken } from '@/utils/auth/tokenManager';

export interface User {
    id: string;
    email: string;
    name?: string;
    role?: string;
}

export const userService = {
    async getAllWorkspaceUsers(): Promise<User[]> {
        try {
            const token = getAuthToken();
            const response = await api.get("/user", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data?.data || [];
        } catch (e) {
            console.error('Error fetching all workspace users:', e);
            return [];
        }
    }
}